export function translate(k: string, replacements = {}) {
    return (window as any).translate(k, replacements)
}

export function generateRoute(name: string) {
    return (window as any).generateRoute(name)
}
